<template>
    <div class="shortcut_btn">
        <div class="header">
            <div class="left">{{ $t('channel.shortcutBtn') }}</div>
            <div class="saveBtn" @click="save">
                <i class="guoran-tongyichicun-16-03-baocun iconfont"></i>
                {{ $t('channel.save') }}
            </div>
        </div>
        <div class="shortcut_content">
            <div class="shortcut_left">
                <div class="btn_view_type_row">
                    <span class="shortcut_left_title">{{ $t('shortcut.buttonDisplayMode') }}</span>
                    <el-tooltip effect="dark" :content="$t('shortcut.showAllDesc')" placement="top">
                        <div class="btn_view_type" :class="[viewType == 0 ? 'btn_view_type_active' : '']"
                            @click="changeBtnViewType(0)">
                            <div class="btn_view_title">
                                {{ $t('shortcut.showAll') }}
                            </div>
                            <div class="btn_view_icon">
                                <i class="el-icon-check"></i>
                            </div>
                        </div>
                    </el-tooltip>
                    <el-tooltip effect="dark" :content="$t('shortcut.showByAgentDesc')" placement="top">
                        <div class="btn_view_type" :class="[viewType == 1 ? 'btn_view_type_active' : '']"
                            @click="changeBtnViewType(1)">
                            <div class="btn_view_title">
                                {{ $t('shortcut.showByAgent') }}
                            </div>
                            <div class="btn_view_icon">
                                <i class="el-icon-check"></i>
                            </div>
                        </div>
                    </el-tooltip>
                    <el-tooltip effect="dark" :content="$t('shortcut.showByGroupDesc')" placement="top">
                        <div class="btn_view_type" :class="[viewType == 2 ? 'btn_view_type_active' : '']"
                            @click="changeBtnViewType(2)">
                            <div class="btn_view_title">
                                {{ $t('shortcut.showByGroup') }}
                            </div>
                            <div class="btn_view_icon">
                                <i class="el-icon-check"></i>
                            </div>
                        </div>
                    </el-tooltip>
                    <div class="btn_view_type_actions" v-if="viewType == 2">
                        <el-button type="primary" size="mini" @click="openGroupConfig()">{{ $t('shortcut.addGroup')
                            }}</el-button>
                    </div>
                </div>
                <template v-if="viewType == 0">
                    <div class="shortcut_content_list_head" v-if="shortcutBtnList.length > 0">
                        <div class="shortcut_content_title">
                            {{ $t('shortcut.button') }}
                        </div>
                        <div class="shortcut_content_desc">
                            {{ $t('shortcut.description') }}
                        </div>
                    </div>
                    <div class="drop_content" ref="dropContent">
                        <div v-for="(item, index) in shortcutBtnList" :key="index" class="shortcut_btn_item">
                            <div class="shortcut_btn_item_left">
                                <i class="iconfont guoran-a-16-10"></i>
                            </div>
                            <div class="shortcut_btn_content">
                                <div class="shortcut_btn_title">
                                    {{ item.name }}
                                </div>
                                <div class="shortcut_btn_desc">
                                    {{ item.description }}
                                </div>
                                <div class="shortcut_btn_set" @click="editShortcut(item)">
                                    <i class="iconfont guoran-shezhi1"></i>
                                </div>
                            </div>
                            <div class="shortcut_btn_item_right">
                                <i class="iconfont guoran-a-16-09" @click="deleteShortcut(index)"></i>
                            </div>
                        </div>
                    </div>

                    <div class="shortcut_btn_add" @click="addShortcutBtn(null)">
                        <div class="shortcut_btn_add_icon">
                            <i class="el-icon-plus"></i>
                        </div>
                        <span>
                            {{ $t('shortcut.add') }}
                        </span>
                    </div>
                </template>
                <template v-if="viewType == 1">
                    <div class="agent_list" v-for="(agent, agentIndex) in agentBindBotInfos" :key="agent.agentId"
                        :data-list-index="agentIndex">
                        <div class="agent_list_item">
                            <img :src="agent.agentLogoUrl" alt="">
                            <span>{{ agent.agentName }}</span>
                        </div>

                        <div class="shortcut_content_list_head"
                            v-if="agent.shortcutBtnList && agent.shortcutBtnList.length > 0">
                            <div class="shortcut_content_title">
                                {{ $t('shortcut.button') }}
                            </div>
                            <div class="shortcut_content_desc">
                                {{ $t('shortcut.description') }}
                            </div>
                        </div>
                        <div class="agent_drop_content" ref="agentDropContent">
                            <template v-if="agent.shortcutBtnList">
                                <div v-for="(item, index) in agent.shortcutBtnList" :key="index"
                                    class="shortcut_btn_item">
                                    <div class="shortcut_btn_item_left">
                                        <i class="iconfont guoran-a-16-10"></i>
                                    </div>
                                    <div class="shortcut_btn_content">
                                        <div class="shortcut_btn_title">
                                            {{ item.name }}
                                        </div>
                                        <div class="shortcut_btn_desc">
                                            {{ item.description }}
                                        </div>
                                        <div class="shortcut_btn_set" @click="editShortcut(item)">
                                            <i class="iconfont guoran-shezhi1"></i>
                                        </div>
                                    </div>
                                    <div class="shortcut_btn_item_right">
                                        <i class="iconfont guoran-a-16-09"
                                            @click="deleteAgentShortcut(agentIndex, index)"></i>
                                    </div>
                                </div>
                            </template>
                        </div>

                        <div class="shortcut_btn_add" @click="addShortcutBtn(agent)">
                            <div class="shortcut_btn_add_icon">
                                <i class="el-icon-plus"></i>
                            </div>
                            <span>
                                {{ $t('shortcut.add') }}
                            </span>
                        </div>
                    </div>

                </template>
                <template v-if="viewType == 2">
                    <div class="group_list" v-for="(group, groupIndex) in groupList" :key="group.id || group.clientTempId"
                        :data-list-index="groupIndex">
                        <div class="group_list_item">
                            <span class="group_name">{{ group.name }}</span>
                            <div class="group_ops">
                                <i class="iconfont guoran-shezhi1" @click="openGroupConfig(group)"></i>
                                <i v-if="groupIndex !== 0" class="iconfont guoran-a-16-09" @click="deleteGroup(groupIndex)"></i>
                            </div>
                        </div>
                        <div class="shortcut_content_list_head"
                            v-if="group.shortcutBtnList && group.shortcutBtnList.length > 0">
                            <div class="shortcut_content_title">
                                {{ $t('shortcut.button') }}
                            </div>
                            <div class="shortcut_content_desc">
                                {{ $t('shortcut.description') }}
                            </div>
                        </div>
                        <div class="group_drop_content" ref="groupDropContent">
                            <template v-if="group.shortcutBtnList">
                                <div v-for="(item, index) in group.shortcutBtnList" :key="index" class="shortcut_btn_item">
                                    <div class="shortcut_btn_item_left">
                                        <i class="iconfont guoran-a-16-10"></i>
                                    </div>
                                    <div class="shortcut_btn_content">
                                        <div class="shortcut_btn_title">
                                            {{ item.name }}
                                        </div>
                                        <div class="shortcut_btn_desc">
                                            {{ item.description }}
                                        </div>
                                        <div class="shortcut_btn_set" @click="editShortcut(item)">
                                            <i class="iconfont guoran-shezhi1"></i>
                                        </div>
                                    </div>
                                    <div class="shortcut_btn_item_right">
                                        <i class="iconfont guoran-a-16-09" @click="deleteGroupShortcut(groupIndex, index)"></i>
                                    </div>
                                </div>
                            </template>
                        </div>
                        <div class="shortcut_btn_add" @click="addShortcutBtn(null, group)">
                            <div class="shortcut_btn_add_icon">
                                <i class="el-icon-plus"></i>
                            </div>
                            <span>
                                {{ $t('shortcut.add') }}
                            </span>
                        </div>
                    </div>
                </template>
            </div>

        </div>
        <DialogView :fastSelectList="shortcutBtnList" :agentBindBotInfos="agentBindBotInfos" :bindDetail="bindDetail"
            :shortcutBtnType="viewType" :groupList="groupList"></DialogView>
        <Popup v-if="btnVisible" @closeEvent="close">
            <div slot="popup-name" class="p-name"> {{ title }}</div>
            <div slot="popup-con-c" class="p-content">
                <div class="btn_name">
                    {{ $t('shortcut.buttonName') }}
                    <span style="color: red;">*</span>
                </div>
                <div class="btn_name_input">
                    <el-popover placement="bottom-start" trigger="click" popper-class="icon_popover">
                        <div class="icon_content">
                            <div class="icon_list">
                                <div class="icon_item" v-for="(icon, index) in iconList" @click="changeIcon(icon)"
                                    :key="index">
                                    <SvgOrIcon :icon="icon" iconClass="iconfont">
                                    </SvgOrIcon>
                                    <!-- <SvgOrIcon></SvgOrIcon> -->
                                </div>
                            </div>
                            <div class="icon_upload">
                                <el-upload class="upload-demo" multiple
                                    action="https://jsonplaceholder.typicode.com/posts/" :http-request="uploadAction"
                                    :before-upload="beforeUpload" :show-file-list="false">
                                    <div class="upload_btn">
                                        <i class="plus el-icon-plus"></i>
                                    </div>
                                </el-upload>
                                <span class="des">
                                    {{ $t('shortcut.tip1') }}
                                    <a href="https://www.iconfont.cn/" target="_blank">iconfont</a>
                                    {{ $t('shortcut.find') }}
                                </span>
                            </div>
                        </div>
                        <div slot="reference" class="icon_set_btn">
                            <SvgOrIcon :icon="shortcutBtn.icon" iconClass="iconfont">
                            </SvgOrIcon>
                        </div>
                    </el-popover>
                    <el-input v-model="shortcutBtn.name" size="small" ref="shortcutBtnNameIpt"
                        :placeholder="$t('shortcut.pleaseInputButtonName')"></el-input>
                </div>
                <div class="btn_name">
                    {{ $t('shortcut.belongGroup') }}
                    <span style="color: red;">*</span>
                </div>
                <div class="btn_name_input">
                    <el-select v-model="shortcutBtn.groupId" :placeholder="$t('shortcut.pleaseSelectGroup')" size="small">
                        <el-option v-for="group in groupList" :key="group.id || group.clientTempId"
                            :label="group.name" :value="group.id || group.clientTempId">
                        </el-option>
                    </el-select>
                </div>
                <div class="btn_name">
                    {{ $t('shortcut.clickAction') }}
                    <span style="color: red;">*</span>
                </div>
                <div class="btn_name_content">
                    <div class="btn_name_input"
                        :class="[shortcutBtn.actionType != 'AGENT' ? 'btn_name_input_plugin' : '']">
                        <el-select v-model="shortcutBtn.actionType" :placeholder="$t('shortcut.pleaseSelect')"
                            size="small" style="width: 130px;flex: none;" @change="changeActionType">
                            <el-option v-for="item in actionOptions" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                        <el-dropdown @command="changAgent" placement="bottom-start" trigger="click">
                            <div class="agent_name">
                                <template v-if="currentAgent">
                                    <img :src="currentAgent.agentLogoUrl" alt="">
                                    <span class="agent_name_text">{{ currentAgent.agentName }}</span>
                                </template>
                                <template v-else>
                                    <span class="agent_name_text_placeholder">{{ $t('shortcut.pleaseSelectAgent')
                                        }}</span>
                                </template>
                                <i class="el-icon-arrow-down el-icon--right"></i>
                            </div>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item v-for="agent in agentBindBotInfos" :key="agent.agentId"
                                    :command="agent.agentId" class="agent_info_dropdown">
                                    <img :src="agent.agentLogoUrl" alt="">
                                    <span class="agent_name_info">{{ agent.agentName }}</span>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <template v-if="shortcutBtn.actionType == 'PLUGIN'">
                            <el-popover placement="bottom-start" width="400" trigger="click" popper-class="tree-popover"
                                ref="popoverPlugin">
                                <el-tree :data="pluginOptions" default-expand-all :expand-on-click-node="false"
                                    @node-click="pluginChange">
                                    <div class="custom-tree-node" slot-scope="{ data }">
                                        <div class="node-left">
                                            <img :src="data.imageUrl" alt="">
                                            {{ data.name }}
                                        </div>
                                        <i v-if="currentPublic && currentPublic.id == data.id"
                                            class="el-icon-check"></i>
                                    </div>
                                </el-tree>
                                <div class="agent_name" slot="reference">
                                    <template v-if="currentPublic">
                                        <img :src="currentPublic.imageUrl" alt="">
                                        <span class="as_name_text">{{ currentPublic.name }}</span>
                                    </template>
                                    <template v-else>
                                        <span class="as_name_text_placeholder">{{ $t('shortcut.pleaseSelectPlugin')
                                            }}</span>
                                    </template>
                                    <i class="el-icon-arrow-down el-icon--right"></i>
                                </div>
                            </el-popover>
                        </template>
                        <template v-if="shortcutBtn.actionType == 'WORKFLOW'">
                            <el-popover placement="bottom-start" width="400" trigger="click" popper-class="tree-popover"
                                ref="popoverWork">
                                <el-tree :data="treeLLMBot" default-expand-all :expand-on-click-node="false"
                                    @node-click="changAgentAsWorkFlow">
                                    <div class="custom-tree-node" slot-scope="{ data }">
                                        <div class="node-left">
                                            <img :src="data.logoUrl" alt="">
                                            {{ data.name }}
                                        </div>
                                        <i v-if="currentWorkFlow && currentWorkFlow.id == data.id"
                                            class="el-icon-check"></i>
                                    </div>
                                </el-tree>
                                <div class="agent_name" slot="reference">
                                    <template v-if="currentWorkFlow">
                                        <img :src="currentWorkFlow.logoUrl" alt="">
                                        <span class="as_name_text">{{ currentWorkFlow.name }}</span>
                                    </template>
                                    <template v-else>
                                        <span class="as_name_text_placeholder">{{ $t('shortcut.pleaseSelectWorkflow')
                                            }}</span>
                                    </template>
                                    <i class="el-icon-arrow-down el-icon--right"></i>
                                </div>
                            </el-popover>
                        </template>
                        <template v-if="shortcutBtn.actionType == 'ONLINE_SEARCH'">
                            <div class="agent_name">
                                {{ $t('shortcut.executeOnlineSearch') }}
                            </div>
                        </template>
                        <template v-if="shortcutBtn.actionType == 'DEEPSEEK'">
                            <div class="agent_name">
                                {{ $t('shortcut.executeDeepSeek') }}
                            </div>
                        </template>
                        <template v-if="shortcutBtn.actionType == 'SEND_LINK'">
                            <div class="agent_name">
                                {{ $t('shortcut.executeOpenLink') }}
                            </div>
                        </template>
                    </div>
                    <div class="switch-cont" v-if="shortcutBtn.actionType == 'AGENT'">
                        <div class="switch">
                            <el-switch @click.native.prevent="changeExampleQuestion('switch')" :width="42"
                                v-model="shortcutBtn.openExampleQuestion" active-color="#366AFF"
                                inactive-color="#E2E2E2">
                                >
                            </el-switch>
                            <span class="switch-open-icon" @click="changeExampleQuestion('open')"
                                v-if="shortcutBtn.openExampleQuestion"><i class="iconfont guoran-a-16-17"></i></span>
                            <span class="switch-close-icon" @click="changeExampleQuestion('close')"
                                v-if="!shortcutBtn.openExampleQuestion"><i class="arsenal_icon arsenalcuo1"></i></span>
                        </div>
                        <div class="item-title">
                            {{ $t('shortcut.showAgentExampleQuestion') }}
                        </div>
                    </div>
                    <div class="switch-cont" v-if="shortcutBtn.actionType == 'PLUGIN'">
                        <div class="switch">
                            <el-switch @click.native.prevent="changePluginQuestion('switch')" :width="42"
                                v-model="shortcutBtn.openPluginQuestion" active-color="#366AFF"
                                inactive-color="#E2E2E2">
                                >
                            </el-switch>
                            <span class="switch-open-icon" @click="changePluginQuestion('open')"
                                v-if="shortcutBtn.openPluginQuestion"><i class="iconfont guoran-a-16-17"></i></span>
                            <span class="switch-close-icon" @click="changePluginQuestion('close')"
                                v-if="!shortcutBtn.openPluginQuestion"><i class="arsenal_icon arsenalcuo1"></i></span>
                        </div>
                        <div class="item-title">
                            {{ $t('shortcut.showPluginExampleQuestion') }}
                        </div>
                    </div>
                    <div class="switch-cont" v-if="shortcutBtn.actionType == 'WORKFLOW'">
                        <div class="switch">
                            <el-switch @click.native.prevent="changeWorkFlowQuestion('switch')" :width="42"
                                v-model="shortcutBtn.openWorkFlowQuestion" active-color="#366AFF"
                                inactive-color="#E2E2E2">
                                >
                            </el-switch>
                            <span class="switch-open-icon" @click="changeWorkFlowQuestion('open')"
                                v-if="shortcutBtn.openWorkFlowQuestion"><i class="iconfont guoran-a-16-17"></i></span>
                            <span class="switch-close-icon" @click="changeWorkFlowQuestion('close')"
                                v-if="!shortcutBtn.openWorkFlowQuestion"><i class="arsenal_icon arsenalcuo1"></i></span>
                        </div>
                        <div class="item-title">
                            {{ $t('shortcut.showWorkflowExampleQuestion') }}
                        </div>
                    </div>
                    <div class="switch-cont" v-if="shortcutBtn.actionType != 'SEND_LINK'">
                        <div class="switch">
                            <el-switch @click.native.prevent="changeEnableSendText('switch')" :width="42"
                                v-model="shortcutBtn.enableSendText" active-color="#366AFF" inactive-color="#E2E2E2">
                                >
                            </el-switch>
                            <span class="switch-open-icon" @click="changeEnableSendText('open')"
                                v-if="shortcutBtn.enableSendText"><i class="iconfont guoran-a-16-17"></i></span>
                            <span class="switch-close-icon" @click="changeEnableSendText('close')"
                                v-if="!shortcutBtn.enableSendText"><i class="arsenal_icon arsenalcuo1"></i></span>
                        </div>
                        <div class="item-title">
                            {{ $t('shortcut.enableSendContent') }}
                        </div>
                    </div>
                    <el-input v-show="shortcutBtn.enableSendText && shortcutBtn.actionType != 'SEND_LINK'" type="textarea" :rows="3"
                        :placeholder="$t('shortcut.pleaseInputSendContent')" v-model="shortcutBtn.sendText">
                    </el-input>
                    <el-input v-if="shortcutBtn.actionType == 'SEND_LINK'" v-model="shortcutBtn.sendText"
                        @blur="handleSendLinkBlur"
                        :placeholder="$t('shortcut.pleaseConfigLinkAddress')" size="small">
                    </el-input>

                </div>
                <div class="btn_name">
                    {{ $t('shortcut.description') }}
                    <span style="color: red;">*</span>
                </div>
                <el-input type="textarea" :rows="3" :placeholder="$t('shortcut.pleaseInputDescription')"
                    v-model="shortcutBtn.description">
                </el-input>
            </div>
            <div slot="dialog-footer" class="p-footer">
                <el-button @click="close" round class="cancel-btn">{{ $t('shortcut.cancel') }}</el-button>
                <el-button type="primary" @click="saveBtn" round class="confirm-btn">{{ $t('shortcut.save')
                    }}</el-button>
            </div>
        </Popup>
        <Popup v-if="groupVisible" @closeEvent="closeGroupConfig">
            <div slot="popup-name" class="p-name"> {{ groupTitle }}</div>
            <div slot="popup-con-c" class="p-content">
                <div class="btn_name">
                    {{ $t('shortcut.groupName') }}
                    <span style="color: red;">*</span>
                </div>
                <el-input v-model="groupForm.name" size="small" :placeholder="$t('shortcut.pleaseInputGroupName')"></el-input>
                <identification-condition
                    ref="groupPermissionCondition"
                    :hideKnowledgeCondition="true"
                    @saveKnowledgeScope="syncGroupPermissionConfig">
                </identification-condition>
            </div>
            <div slot="dialog-footer" class="p-footer">
                <el-button @click="closeGroupConfig" round class="cancel-btn">{{ $t('shortcut.cancel') }}</el-button>
                <el-button type="primary" @click="saveGroupConfig" round class="confirm-btn">{{ $t('shortcut.save')
                    }}</el-button>
            </div>
        </Popup>
    </div>
</template>

<script>
import Popup from '../../../components/popup.vue';
import DialogView from './dialogView.vue';
import SvgOrIcon from '../../../components/svgOrIcon.vue';
import IdentificationCondition from '../../../components/identificationCondition.vue';
import { upload } from '../../../assets/js/AliyunIssUtil'
import Sortable from "sortablejs";
export default {
    props: {
        bindDetail: {
            type: Object,
            default: () => ({}),
        },
    },
    components: {
        DialogView,
        Popup,
        SvgOrIcon,
        IdentificationCondition
    },
    data() {
        return {
            allShortcutBtnList: [],
            shortcutBtnList: [],
            groupList: [],
            viewType: 0,
            btnVisible: false,
            groupVisible: false,
            groupTitle: "",
            iconList: [
                'guoran-zhishi2',
                'guoran-icon-deepseek',
                'guoran-a-designstripecom',
                'guoran-mofabang',
                'guoran-AIshengchengicon',
                'guoran-AIshengchengku',
                'guoran-wenshengtu01',
                'guoran-fensizengchang',
                'guoran-zhinengsousuo',
                'guoran-zhinengsousuo1',
                'guoran-xiaoxi2',
                'guoran-gongdan2',
                'guoran-zhishiku1',
                'guoran-dengpao',
                'guoran-nengliguanli',
                'guoran-fenlei',
            ],
            actionOptions: [],
            agentList: [],
            agentBindBotInfos: [],
            props: {},
            currentAgent: null,
            currentPublic: null,
            currentWorkFlow: null,
            pluginOptions: [],
            shortcutBtn: {
                icon: "",
                name: "",
                actionType: "AGENT",
                enableSendText: false,
                description: "",
                useAgentId: 'ALL',
                sendText: '',
                pluginId: '',
                agentId: '',
                workFlowId: '',
                openExampleQuestion: false,
                openPluginQuestion: false,
                openWorkFlowQuestion: false,
                groupId: '',
            },
            groupForm: {
                id: null,
                clientTempId: '',
                bindCode: '',
                name: '',
                permissionConfig: '',
            },
            workFlowList: [],
            agentAsWorkFlow: [],
            treeLLMBot: [],
            llmBotList: [],
            modelList: [],
            currentModel: null,
            title: ""
        };
    },
    created() {
        this.actionOptions = [
            { value: 'AGENT', label: this.$t('shortcut.callAgent') },
            { value: 'PLUGIN', label: this.$t('shortcut.callPlugin')},
            { value: 'WORKFLOW', label: this.$t('shortcut.callWorkflow')},
            { value: 'DEEPSEEK', label: this.$t('shortcut.callDeepSeek')},
            { value: 'ONLINE_SEARCH', label: this.$t('shortcut.callOnlineSearch')},
            { value: 'SEND_CONTENT', label: this.$t('shortcut.callSendContent')},
            { value: 'SEND_LINK', label: this.$t('shortcut.callSendLink')},
        ]
    },
    mounted() {
        this.shortcutBtn.icon = this.iconList[0];
        this.viewType = this.bindDetail.shortcutBtnType;
        if (this.bindDetail.wechatBindAgent) {
            this.agentBindBotInfos = JSON.parse(JSON.stringify(this.bindDetail.wechatBindAgent.agentBindBotInfos))
            console.log(this.agentBindBotInfos, 'agentBindBotInfos');
        }

        this.getGroupList()
        this.getShortcutBtnList()
        // this.props = {
        //     value: 'id',
        //     label: 'name',
        //     lazy: true,
        //     lazyLoad: this.lazyLoad
        // }
        // this.getPluginList()
        this.getWorkFlow()
        this.getLLmBotList()
        this.getAgentModelList()
        this.$nextTick(() => {
            this.initSort()
        })
    },
    methods: {
        filterShortcutBtnList() {
            this.shortcutBtnList = this.allShortcutBtnList.filter(item => {
                return item.useAgentId == "ALL"
            })
            this.agentBindBotInfos.forEach(agent => {
                this.$set(agent, 'shortcutBtnList', this.allShortcutBtnList.filter(item => {
                    return item.useAgentId == agent.agentId
                }))
            })
            if (this.groupList.length > 0) {
                const defaultGroupKey = this.groupList[0].id || this.groupList[0].clientTempId
                this.allShortcutBtnList.forEach(item => {
                    if (!item.groupId) {
                        item.groupId = defaultGroupKey
                    }
                })
            }
            this.groupList.forEach(group => {
                let groupKey = group.id || group.clientTempId
                this.$set(group, 'shortcutBtnList', this.allShortcutBtnList.filter(item => {
                    return (item.groupId || '') == groupKey
                }))
            })
        },
        getGroupList() {
            this.$http.get("/api-open/shortcutBtn/group/list?bindCode=" + this.bindDetail.bindCode).then(res => {
                if (res.data.code == 0) {
                    let groups = res.data.data || []
                    this.groupList = groups.map(item => ({
                        ...item,
                        permissionConfig: item.permissionConfig || '',
                        shortcutBtnList: []
                    }))
                    this.filterShortcutBtnList()
                }
            })
        },
        getShortcutBtnList() {
            this.$http.get("/api-open/shortcutBtn/list?bindCode=" + this.bindDetail.bindCode).then(res => {
                if (res.data.code == 0) {
                    let data = res.data.data;
                    this.allShortcutBtnList = data;
                    this.filterShortcutBtnList()


                }
            })
        },
        getPluginList() {
            let url =
                "/api-open/channel/access/llm-bot/plugin-in-scope?bindCode=" +
                this.currentAgent.bindCode +
                "&tel=" +
                "&userId=" +
                "323202681129076628";
            this.$http.get(url).then((res) => {
                let tampArr = [];
                console.log(res.data.data);

                res.data.data.forEach((item) => {
                    item.imageUrl =
                        item.avatar != null
                            ? item.avatar
                            : "https://guoranopen-zjk.oss-cn-zhangjiakou.aliyuncs.com/front-oss/null/2023/12/12/20/27/a102d00144244d628371c00e779ba213/feishu_logo_002.png";
                    item.isShowPlugin = true;
                    item.checked = false;
                    item.children = [];
                    item.name = item.llmBot.name;
                    item.id = item.llmBot._id;
                    item.plugins.forEach((pluginCell) => {
                        pluginCell.pluginTools.forEach((pluginToolCell) => {
                            item.children.push({
                                name: pluginToolCell.name,
                                id: pluginToolCell._id,
                                checked: false,
                                imageUrl:
                                    pluginCell.avatar != null
                                        ? pluginCell.avatar
                                        : "https://static.guoranbot.com/chajian.png",
                                botName: item.llmBot.name,
                                pluginDesc: pluginCell.description,
                                pluginToolDesc: pluginToolCell.description,
                                botId: item.llmBot._id,
                                pluginId: pluginCell._id,
                                avatar:
                                    pluginCell.avatar != null
                                        ? pluginCell.avatar
                                        : "https://static.guoranbot.com/chajian.png",
                                exampleQuestions: pluginToolCell.exampleQuestions,
                                type: "plugin",
                            });
                        });
                    });
                    tampArr.push(item);
                });
                this.pluginOptions = [...tampArr];
                if (this.shortcutBtn.pluginId) {
                    this.pluginOptions.forEach(item => {
                        item.children.forEach(plugin => {
                            if (plugin.id == this.shortcutBtn.pluginId) {
                                this.currentPublic = plugin
                            }
                        })
                    })
                }
                // this.pluginOptionsCopy = JSON.stringify(this.pluginOptions);

                // 设置模型待选择列表和当前模型
                // let modelListTemp = [];
                // if (res.data.data && res.data.data.length) {
                //     res.data.data[0].llmBot.modelParametersV1.forEach(item => {
                //         if (!item.model.deleted) {
                //             modelListTemp.push(item);
                //         }
                //     })
                // } else {
                //     modelListTemp = [];
                // }
                // this.$set(this, "modelList", modelListTemp);
                // this.preModelList = JSON.parse(JSON.stringify(this.modelList));
                // if (this.preModelList.length != 0) {
                //     this.preModelList.forEach((item) => {
                //         item.checked = false;
                //     });
                //     this.preModelList[0].checked = true;
                //     this.activeSwitchModel = this.modelList[0];
                //     console.log(947, this.activeSwitchModel);
                //     this.preActiveSwitchModel = this.modelList[0];
                // }
            });
        },
        getWorkFlow() {
            let mainId = localStorage.getItem('_mainId')
            let url = "/tag-api/workflow/list?mainId=" + mainId + '&status=0&pageNo=1&pageSize=1000';
            this.$http.get(url).then(res => {
                if (res.data.code == 0 && res.data.data && res.data.data.workflows) {
                    this.workFlowList = res.data.data.workflows;
                    // let total = res.data.data.total;
                    // console.log('total', total, Number(this.currentPage * 20), total > Number(this.currentPage * 20))
                    // if (total > Number(this.currentPage * 20)) {
                    //     this.hasMore = true;
                    // } else {
                    //     this.hasMore = false;
                    // }
                }
            })
        },
        save() {
            this.$http.post("/api-open/shortcutBtn/updateShortcutBtnType?bindId=" + this.bindDetail.id + "&shortcutBtnType=" + this.viewType).then(res => {
                if (res.data.code == 0) {
                    this.persistGroupsAndButtons()
                }
            })
            // const selectedButtons = this.shortcutBtnList.filter(item => item.value);
            // if (selectedButtons.length > 0) {
            //     this.$emit('save', selectedButtons);
            // } else {
            //     this.$message.warning(this.$t('channel.selectShortcut'));
            // }
        },
        changeBtnViewType(type) {
            this.viewType = type
            this.filterShortcutBtnList()
            this.$nextTick(() => {
                this.initSort()
            })
        },
        addShortcutBtn(agent, group) {
            // this.shortcutBtn = {
            //     icon: this.iconList[0],
            //     name: "",
            //     actionType: "AGENT",
            //     enableSendText: false,
            //     description: "",
            //     useAgentId: 'ALL',
            //     sendText: '',
            //     pluginId: '',
            //     agentId: '',
            //     workFlowId: '',
            //     openExampleQuestion: false,
            //     openPluginQuestion: false,
            //     openWorkFlowQuestion: false,
            //     openDeepSeekQuestion: false,
            // }
            this.title = this.$t('shortcut.addShortcutButton')
            this.$set(this, 'shortcutBtn', {
                icon: this.iconList[0],
                name: "",
                actionType: "AGENT",
                enableSendText: false,
                description: "",
                useAgentId: 'ALL',
                sendText: '',
                pluginId: '',
                agentId: '',
                workFlowId: '',
                openExampleQuestion: false,
                openPluginQuestion: false,
                openWorkFlowQuestion: false,
                openDeepSeekQuestion: false,
                groupId: this.getDefaultGroupId(),
            })
            this.currentAgent = null
            this.currentPublic = null
            this.currentWorkFlow = null
            this.pluginOptions = []
            this.agentAsWorkFlow = []
            if (agent) {
                this.shortcutBtn.useAgentId = agent.agentId
            }
            if (group) {
                this.shortcutBtn.groupId = group.id || group.clientTempId
            }
            this.btnVisible = true
        },
        close() {
            this.btnVisible = false
        },
        saveBtn() {
            if (this.shortcutBtn.name == "") {
                this.$message.warning(this.$t('shortcut.inputButtonName'))
                return
            }
            if (this.shortcutBtn.description == "") {
                this.$message.warning(this.$t('shortcut.inputButtonDesc'))
                return
            }
            if (this.shortcutBtn.actionType && !this.shortcutBtn.agentId) {
                this.$message.warning(this.$t('shortcut.selectAgent'))
                return
            }
            if (this.shortcutBtn.actionType == "PLUGIN" && !this.shortcutBtn.pluginId) {
                this.$message.warning(this.$t('shortcut.selectPlugin'))
                return
            }
            if (this.shortcutBtn.actionType == "WORKFLOW" && !this.shortcutBtn.workFlowId) {
                this.$message.warning(this.$t('shortcut.selectWorkflow'))
                return
            }
            if (!this.shortcutBtn.groupId) {
                this.$message.warning(this.$t('shortcut.selectGroup'))
                return
            }
            if (this.shortcutBtn.actionType == "SEND_LINK") {
                let link = this.normalizeLinkAddress(this.shortcutBtn.sendText)
                if (!link) {
                    this.$message.warning(this.$t('shortcut.inputLinkAddress'))
                    return
                }
                if (!this.isValidHttpLink(link)) {
                    this.$message.warning(this.$t('shortcut.invalidLinkAddress'))
                    return
                }
                this.shortcutBtn.sendText = link
            }
            if (this.shortcutBtn.actionType == "SEND_CONTENT" && !this.shortcutBtn.sendText.trim()) {
                this.$message.warning(this.$t('shortcut.inputSendContent'))
                return
            }
            if (this.shortcutBtn.enableSendText && !this.shortcutBtn.sendText.trim()) {
                this.$message.warning(this.$t('shortcut.inputSendContent'))
                return
            }
            // console.log(this.shortcutBtn, 'btnVisible');
            // if (this.shortcutBtn.id) {
            //     this.shortcutBtnList.forEach(item => {
            //         if (item.id == this.shortcutBtn.id) {
            //             item = this.shortcutBtn
            //         }
            //     })
            // } else {
            // }
            if (this.shortcutBtn.useAgentId == 'ALL') {
                if (this.shortcutBtn.id) {
                    for (let index = 0; index < this.shortcutBtnList.length; index++) {
                        let item = this.shortcutBtnList[index];
                        if (item.id == this.shortcutBtn.id) {
                            console.log(item.id, this.shortcutBtn, 11111);
                            this.$set(this.shortcutBtnList, index, this.shortcutBtn)
                            break;
                        }
                    }
                } else {
                    this.$set(this.shortcutBtn, "id", new Date().getTime())
                    this.$set(this.shortcutBtn, "savePending", true)
                    this.shortcutBtnList.push(this.shortcutBtn)
                }
            } else {
                for (let index = 0; index < this.agentBindBotInfos.length; index++) {
                    let agent = this.agentBindBotInfos[index];
                    if (agent.agentId == this.shortcutBtn.useAgentId) {
                        if (this.shortcutBtn.id) {
                            for (let i = 0; i < agent.shortcutBtnList.length; i++) {
                                if(agent.shortcutBtnList[i].id == this.shortcutBtn.id) {
                                    this.$set(agent.shortcutBtnList, i, this.shortcutBtn)
                                }
                            }
                        } else {
                            this.$set(this.shortcutBtn, "id", new Date().getTime())
                            this.$set(this.shortcutBtn, "savePending", true)
                            agent.shortcutBtnList.push(this.shortcutBtn)
                        }
                    }
                }
                console.log(this.agentBindBotInfos, 'this.agentBindBotInfos');

            }
            this.btnVisible = false
            this.rebuildAllShortcutBtnList()
            this.filterShortcutBtnList()
        },
        changeIcon(icon) {
            this.shortcutBtn.icon = icon
        },
        // 上传校验
        beforeUpload(file) {
            const isSvg = file.type.includes('svg')
            if (!isSvg) {
                this.$message.error(this.$t('shortcut.uploadSvgIcon'))
            }
            return isSvg
        },

        uploadAction({ file }) {
            upload({}, file).then((res) => {
                this.shortcutBtn.icon = res.url
                this.$forceUpdate()
                this.$refs.shortcutBtnNameIpt.focus()
            })
        },

        changeActionType() {
            this.currentPublic = null
            this.currentAgent = null
            this.currentWorkFlow = null
            if (this.shortcutBtn.actionType == "SEND_CONTENT") {
                this.shortcutBtn.enableSendText = true
            } else if (this.shortcutBtn.actionType == "SEND_LINK") {
                this.shortcutBtn.enableSendText = false
            }
            this.resetDesc()
        },
        changAgent(command, type) {
            this.currentAgent = this.agentBindBotInfos.find(item => {
                return item.agentId == command
            })
            if (this.currentAgent == null) {
                return
            }
            console.log(this.currentAgent, 'currentAgent');
            this.shortcutBtn.agentId = this.currentAgent.agentId
            this.getPluginList()
            let list = this.currentAgent.bindBotInfos ?
                this.currentAgent.bindBotInfos.filter(bot => { return bot.botType == 10 }).map(bot => { return bot.botId })
                : [];
            let treeLLMBot = []
            this.llmBotList.forEach(llm => {
                if (list.includes(llm.bot.id)) {
                    let bot = llm.llmBot.llmBot
                    treeLLMBot.push({
                        id: bot.id,
                        name: bot.name,
                        bindWorkflows: bot.bindWorkflows,
                        logoUrl: bot.avatar,
                    })
                }
            })
            console.log(treeLLMBot, 'treeLLMBot');

            treeLLMBot.forEach(llm => {
                let children = this.workFlowList.filter(item => {
                    return llm.bindWorkflows &&
                        llm.bindWorkflows.includes(item._id)
                })
                llm.children = children.map(ele => {
                    return {
                        ...ele,
                        name: ele.name,
                        id: ele._id
                    }
                })
            })
            this.treeLLMBot = treeLLMBot
            if (this.shortcutBtn.workFlowId) {
                treeLLMBot.forEach(item => {
                    item.children.forEach(workflow => {
                        if (workflow.id == this.shortcutBtn.workFlowId) {
                            this.currentWorkFlow = workflow
                        }
                    })
                })
            }
            if (type != "edit") {
                this.resetDesc()
            }
            // this.agentAsWorkFlow = this.workFlowList.filter(item => {
            //     return this.currentAgent.bindWorkflows &&
            //         this.currentAgent.bindWorkflows.includes(item._id)
            // })
        },
        getLLmBotList() {
            let url = "/api-open/bot/list/llm"
            this.$http.get(url).then(res => {
                if (res.data.code == 0 && res.data.data) {
                    this.llmBotList = res.data.data
                }
            })
        },
        pluginChange(data) {
            if (data.children) {
                return
            }
            this.currentPublic = data
            this.shortcutBtn.pluginId = data.id
            this.$nextTick(() => {
                this.$refs.popoverPlugin.doClose()
            })
        },
        changAgentAsWorkFlow(data) {
            if (data.children) {
                return
            }
            this.currentWorkFlow = data
            this.shortcutBtn.workFlowId = data.id
            this.$nextTick(() => {
                this.$refs.popoverWork.doClose()
            })
        },
        changeEnableSendText(type) {
            if (this.shortcutBtn.actionType == "SEND_CONTENT") {
                this.$set(this.shortcutBtn, 'enableSendText', true)
                return
            }
            if (this.shortcutBtn.actionType == "SEND_LINK") {
                this.$set(this.shortcutBtn, 'enableSendText', false)
                return
            }
            if (type === "open") {
                this.$set(this.shortcutBtn, 'enableSendText', false)
            } else if (type === "close") {
                this.$set(this.shortcutBtn, 'enableSendText', true)
            }
        },
        changeExampleQuestion(type) {
            if (type === "open") {
                this.$set(this.shortcutBtn, 'openExampleQuestion', false)
            } else if (type === "close") {
                this.$set(this.shortcutBtn, 'openExampleQuestion', true)
            }
        },
        changePluginQuestion(type) {
            if (type === "open") {
                this.$set(this.shortcutBtn, 'openPluginQuestion', false)
            } else if (type === "close") {
                this.$set(this.shortcutBtn, 'openPluginQuestion', true)
            }
        },
        changeWorkFlowQuestion(type) {
            if (type === "open") {
                this.$set(this.shortcutBtn, 'openWorkFlowQuestion', false)
            } else if (type === "close") {
                this.$set(this.shortcutBtn, 'openWorkFlowQuestion', true)
            }
        },
        editShortcut(item) {
            this.title = this.$t('shortcut.editShortcutButton')
            this.shortcutBtn = JSON.parse(JSON.stringify(item))
            if (!this.shortcutBtn.groupId) {
                this.shortcutBtn.groupId = this.getDefaultGroupId()
            }
            if (this.shortcutBtn.actionType == "SEND_CONTENT") {
                this.shortcutBtn.enableSendText = true
            } else if (this.shortcutBtn.actionType == "SEND_LINK") {
                this.shortcutBtn.enableSendText = false
            }
            if (this.shortcutBtn.agentId) {
                this.changAgent(this.shortcutBtn.agentId, "edit")
            }
            // if(this.shortcutBtn.agentId){
            //     this.currentAgent = this.agentBindBotInfos.find(agent => {
            //         return agent.agentId == this.shortcutBtn.agentId
            //     })
            // }
            // if(this.shortcutBtn.agentId){
            //     this.currentAgent = this.agentBindBotInfos.find(agent => {
            //         return agent.agentId == this.shortcutBtn.agentId
            //     })
            // }
            this.btnVisible = true
        },
        deleteShortcut(index) {
            this.shortcutBtnList.splice(index, 1)
            this.rebuildAllShortcutBtnList()
            this.filterShortcutBtnList()
        },
        deleteAgentShortcut(agentIndex, index) {
            this.agentBindBotInfos[agentIndex].shortcutBtnList.splice(index, 1)
            this.rebuildAllShortcutBtnList()
            this.filterShortcutBtnList()
        },
        deleteGroupShortcut(groupIndex, index) {
            this.groupList[groupIndex].shortcutBtnList.splice(index, 1)
            this.rebuildAllShortcutBtnList()
            this.filterShortcutBtnList()
        },
        getAgentModelList() {
            let url = "/tag-api/model?mainId=" + localStorage.getItem("_mainId") + "&page=1&limit=200&modelParam=true";
            this.$http.get(url).then(res => {
                this.modelList = res.data.data.filter(item => {
                    if (item.modelType == "DEEPSEEK" && item.modelParam && item.modelParam.DeepSeekConfig) {
                        return item.modelParam.DeepSeekConfig.version == "r1";
                    } else {
                        return false
                    }
                });
            })
        },
        resetDesc() {
            let label = this.actionOptions.find(item => { return item.value == this.shortcutBtn.actionType }).label
            if (this.currentAgent) {
                if (this.shortcutBtn.actionType == "AGENT") {
                    this.shortcutBtn.description = '调用智能体: ' + this.currentAgent.agentName
                    // this.shortcutBtn.description = this.$t('shortcutBtn.callAgentWithName', { name: this.currentAgent.agentName })
                } else if (this.shortcutBtn.actionType == "PLUGIN") {
                    this.shortcutBtn.description = '调用智能体: ' + this.currentAgent.agentName + "; " + '调用插件工具'
                    // this.shortcutBtn.description = this.$t('shortcutBtn.callAgentWithPlugin', { name: this.currentAgent.agentName })
                } else if (this.shortcutBtn.actionType == "WORKFLOW") {
                    this.shortcutBtn.description = '调用智能体: ' + this.currentAgent.agentName + "; " + '调用工作流'
                    // this.shortcutBtn.description = this.$t('shortcutBtn.callAgentWithWorkflow', { name: this.currentAgent.agentName })
                } else if (this.shortcutBtn.actionType == "DEEPSEEK") {
                    this.shortcutBtn.description = '调用智能体: ' + this.currentAgent.agentName + "; " + '调用深度思考'
                    // this.shortcutBtn.description = this.$t('shortcutBtn.callAgentWithDeepSeek', { name: this.currentAgent.agentName })
                } else if (this.shortcutBtn.actionType == "ONLINE_SEARCH") {
                    this.shortcutBtn.description = '调用智能体: ' + this.currentAgent.agentName + "; " + '调用联网搜索'
                    // this.shortcutBtn.description = this.$t('shortcutBtn.callAgentWithOnlineSearch', { name: this.currentAgent.agentName })
                } else if (this.shortcutBtn.actionType == "SEND_CONTENT") {
                    this.shortcutBtn.description = '调用智能体: ' + this.currentAgent.agentName + "; " + '发送内容'
                } else if (this.shortcutBtn.actionType == "SEND_LINK") {
                    this.shortcutBtn.description = '调用智能体: ' + this.currentAgent.agentName + "; " + '打开链接'
                }
            }
        },
        normalizeLinkAddress(link) {
            if (!link) {
                return ''
            }
            let value = link.trim()
            if (!value) {
                return ''
            }
            if (!/^https?:\/\//i.test(value)) {
                value = 'https://' + value
            }
            return value
        },
        isValidHttpLink(link) {
            try {
                const url = new URL(link)
                return ['http:', 'https:'].includes(url.protocol)
            } catch (e) {
                return false
            }
        },
        handleSendLinkBlur() {
            if (this.shortcutBtn.actionType !== "SEND_LINK") {
                return
            }
            if (!this.shortcutBtn.sendText || !this.shortcutBtn.sendText.trim()) {
                return
            }
            const link = this.normalizeLinkAddress(this.shortcutBtn.sendText)
            if (!this.isValidHttpLink(link)) {
                this.$message.warning(this.$t('shortcut.invalidLinkAddress'))
                return
            }
            this.shortcutBtn.sendText = link
        },
        initSort() {
            let _this = this;
            if (this.viewType == 0) {
                let box = this.$refs.dropContent;
                new Sortable(box, {
                    ghostClass: "blue-background-class",
                    handle: ".guoran-a-16-10",
                    animation: 500,
                    sort: true,
                    onUpdate: function (event) {
                        //修改items数据顺序
                        let newIndex = event.newIndex,
                            oldIndex = event.oldIndex,
                            $li = box.children[newIndex],
                            $oldLi = box.children[oldIndex];
                        // 先删除移动的节点
                        box.removeChild($li);
                        // 再插入移动的节点到原有节点，还原了移动的操作
                        if (newIndex > oldIndex) {
                            box.insertBefore($li, $oldLi);
                        } else {
                            box.insertBefore($li, $oldLi.nextSibling);
                        }
                        // 更新items数组
                        let item = _this.shortcutBtnList.splice(oldIndex, 1);
                        _this.shortcutBtnList.splice(newIndex, 0, item[0]);
                        _this.rebuildAllShortcutBtnList();
                    },
                });
            } else if (this.viewType == 1) {
                let agentDropContents = this.$refs.agentDropContent;
                console.log(agentDropContents, 'agentDropContents');

                agentDropContents.forEach((box, index) => {
                    new Sortable(box, {
                        ghostClass: "blue-background-class",
                        handle: ".guoran-a-16-10",
                        animation: 500,
                        sort: true,
                        onUpdate: function (event) {
                            //修改items数据顺序
                            let newIndex = event.newIndex,
                                oldIndex = event.oldIndex,
                                $li = box.children[newIndex],
                                $oldLi = box.children[oldIndex];
                            // 先删除移动的节点
                            box.removeChild($li);
                            // 再插入移动的节点到原有节点，还原了移动的操作
                            if (newIndex > oldIndex) {
                                box.insertBefore($li, $oldLi);
                            } else {
                                box.insertBefore($li, $oldLi.nextSibling);
                            }
                            // 更新items数组
                            let item = _this.agentBindBotInfos[index].shortcutBtnList.splice(oldIndex, 1);
                            _this.agentBindBotInfos[index].shortcutBtnList.splice(newIndex, 0, item[0]);
                            console.log(_this.agentBindBotInfos, '_this.agentBindBotInfos_this.agentBindBotInfos');
                            _this.rebuildAllShortcutBtnList();

                        },
                    });
                })
            } else {
                let groupDropContents = this.$refs.groupDropContent;
                if (!groupDropContents) {
                    return
                }
                groupDropContents.forEach((box, index) => {
                    new Sortable(box, {
                        ghostClass: "blue-background-class",
                        handle: ".guoran-a-16-10",
                        animation: 500,
                        sort: true,
                        onUpdate: function (event) {
                            let newIndex = event.newIndex,
                                oldIndex = event.oldIndex,
                                $li = box.children[newIndex],
                                $oldLi = box.children[oldIndex];
                            box.removeChild($li);
                            if (newIndex > oldIndex) {
                                box.insertBefore($li, $oldLi);
                            } else {
                                box.insertBefore($li, $oldLi.nextSibling);
                            }
                            let item = _this.groupList[index].shortcutBtnList.splice(oldIndex, 1);
                            _this.groupList[index].shortcutBtnList.splice(newIndex, 0, item[0]);
                            _this.rebuildAllShortcutBtnList();
                        },
                    });
                })
            }
        },
        getDefaultGroupId() {
            if (!this.groupList.length) {
                return ''
            }
            return this.groupList[0].id || this.groupList[0].clientTempId
        },
        rebuildAllShortcutBtnList() {
            let arr = []
            this.shortcutBtnList.forEach(item => arr.push(item))
            this.agentBindBotInfos.forEach(agent => {
                if (agent.shortcutBtnList) {
                    agent.shortcutBtnList.forEach(item => arr.push(item))
                }
            })
            this.groupList.forEach(group => {
                if (group.shortcutBtnList) {
                    group.shortcutBtnList.forEach(item => arr.push(item))
                }
            })
            const seen = {}
            this.allShortcutBtnList = arr.filter(item => {
                if (!item || !item.id) {
                    return false
                }
                if (seen[item.id]) {
                    return false
                }
                seen[item.id] = true
                return true
            })
        },
        openGroupConfig(group) {
            this.groupTitle = group ? this.$t('shortcut.editGroup') : this.$t('shortcut.addGroup')
            if (group) {
                this.groupForm = {
                    id: group.id || null,
                    clientTempId: group.clientTempId || '',
                    bindCode: this.bindDetail.bindCode,
                    name: group.name,
                    permissionConfig: group.permissionConfig || '',
                }
            } else {
                this.groupForm = {
                    id: null,
                    clientTempId: 'temp_group_' + new Date().getTime(),
                    bindCode: this.bindDetail.bindCode,
                    name: '',
                    permissionConfig: '',
                }
            }
            this.groupVisible = true
            this.$nextTick(() => {
                this.applyGroupPermissionConfigToComponent()
            })
        },
        closeGroupConfig() {
            this.groupVisible = false
        },
        saveGroupConfig() {
            if (!this.groupForm.name || !this.groupForm.name.trim()) {
                this.$message.warning(this.$t('shortcut.inputGroupName'))
                return
            }
            this.syncGroupPermissionConfig()
            if (this.groupForm.id || this.groupForm.clientTempId) {
                let groupKey = this.groupForm.id || this.groupForm.clientTempId
                let idx = this.groupList.findIndex(item => (item.id || item.clientTempId) == groupKey)
                let groupData = {
                    ...this.groupForm,
                    name: this.groupForm.name.trim(),
                    permissionConfig: this.groupForm.permissionConfig ? this.groupForm.permissionConfig.trim() : '',
                    shortcutBtnList: idx > -1 && this.groupList[idx].shortcutBtnList ? this.groupList[idx].shortcutBtnList : []
                }
                if (idx > -1) {
                    this.$set(this.groupList, idx, groupData)
                } else {
                    this.groupList.push(groupData)
                }
            }
            this.groupVisible = false
            this.filterShortcutBtnList()
            this.$nextTick(() => {
                this.initSort()
            })
        },
        getDefaultGroupPermissionConditions() {
            return [{
                type: "ALL",
                relation: null,
                expect: []
            }]
        },
        parseGroupPermissionConfig(configText) {
            if (!configText || !configText.trim()) {
                return this.getDefaultGroupPermissionConditions()
            }
            try {
                const configObj = JSON.parse(configText)
                if (Array.isArray(configObj)) {
                    return configObj.length ? configObj : this.getDefaultGroupPermissionConditions()
                }
                if (configObj && Array.isArray(configObj.conditions)) {
                    return configObj.conditions.length ? configObj.conditions : this.getDefaultGroupPermissionConditions()
                }
            } catch (e) {
                return this.getDefaultGroupPermissionConditions()
            }
            return this.getDefaultGroupPermissionConditions()
        },
        applyGroupPermissionConfigToComponent() {
            const comp = this.$refs.groupPermissionCondition
            if (!comp) {
                return
            }
            const conditions = this.parseGroupPermissionConfig(this.groupForm.permissionConfig)
            comp.pluginCondition = JSON.parse(JSON.stringify(conditions))
        },
        syncGroupPermissionConfig() {
            const comp = this.$refs.groupPermissionCondition
            let conditions = this.getDefaultGroupPermissionConditions()
            if (comp && Array.isArray(comp.pluginCondition) && comp.pluginCondition.length > 0) {
                conditions = JSON.parse(JSON.stringify(comp.pluginCondition))
            }
            const normalized = conditions.length > 0 ? conditions : this.getDefaultGroupPermissionConditions()
            const onlyAll = normalized.length === 1 && normalized[0].type === 'ALL'
            this.groupForm.permissionConfig = JSON.stringify({
                scope: onlyAll ? 0 : 1,
                conditions: normalized
            })
        },
        deleteGroup(index) {
            if (index === 0) {
                this.$message.warning(this.$t('shortcut.defaultGroupCannotDelete'))
                return
            }
            if (this.groupList.length <= 1) {
                this.$message.warning(this.$t('shortcut.keepAtLeastOneGroup'))
                return
            }
            const target = this.groupList[index]
            const targetKey = target.id || target.clientTempId
            const defaultKey = this.groupList[0].id || this.groupList[0].clientTempId
            this.allShortcutBtnList.forEach(item => {
                if ((item.groupId || '') == targetKey) {
                    item.groupId = defaultKey
                }
            })
            this.groupList.splice(index, 1)
            this.filterShortcutBtnList()
            this.$nextTick(() => {
                this.initSort()
            })
        },
        persistGroupsAndButtons() {
            let groupPayload = this.groupList.map((group, idx) => {
                let temp = {
                    id: group.id,
                    clientTempId: group.clientTempId || '',
                    bindCode: this.bindDetail.bindCode,
                    name: group.name,
                    permissionConfig: group.permissionConfig || '',
                    sortId: idx,
                }
                if (group.savePending == true) {
                    delete temp.id
                }
                return temp
            })
            this.$http.post("/api-open/shortcutBtn/group/save", groupPayload).then(groupRes => {
                if (groupRes.data.code != 0) {
                    return
                }
                const serverGroups = groupRes.data.data || []
                const groupKeyMap = {}
                serverGroups.forEach(group => {
                    if (group.clientTempId) {
                        groupKeyMap[group.clientTempId] = group.id
                    }
                    if (group.id) {
                        groupKeyMap[group.id] = group.id
                    }
                })
                this.groupList = serverGroups.map(item => ({
                    ...item,
                    permissionConfig: item.permissionConfig || '',
                    shortcutBtnList: []
                }))
                let arr = []
                this.agentBindBotInfos.forEach(agent => {
                    agent.shortcutBtnList.forEach(item => {
                        arr.push(item)
                    })
                })
                let data = [...this.shortcutBtnList, ...arr]
                data.forEach(item => {
                    item.bindCode = this.bindDetail.bindCode
                    item.mainId = localStorage.getItem('_mainId')
                    item.groupId = groupKeyMap[item.groupId] || this.getDefaultGroupId()
                    if(item.savePending == true) {
                        delete item.savePending
                        delete item.id
                    }
                })
                this.$http.post("/api-open/shortcutBtn/save", data).then(res => {
                    if (res.data.code == 0) {
                        this.$message.success('保存成功！')
                        this.getGroupList()
                        this.getShortcutBtnList()
                        this.$emit("saveSuccess")
                    }
                })
            })
        }
    },
}
</script>

<style lang="less" scoped>
.shortcut_btn {
    height: 100%;
    width: calc(100% - 390px);
    // overflow: auto;
    background-color: #FFFFFF;
    box-sizing: border-box;
    padding: 20px;
    position: relative;


    .header {
        margin-bottom: 14px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .left {
            font-size: 16px;
            color: #000000;
        }
    }

    .saveBtn {
        height: 26px;
        background-color: #366aff;
        color: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 14px;
        font-size: 12px;
        border-radius: 17px;
        cursor: pointer;

        i {
            font-size: 12px;
            padding-right: 4px;
        }
    }

    .shortcut_content {
        display: flex;
        justify-content: space-between;
        height: calc(100% - 50px);
        width: 100%;

        .shortcut_left {
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            overflow-y: auto;
            overflow-x: hidden;

            .shortcut_left_title {
                font-size: 14px;
                color: #000000;
                margin-right: 6px;
                flex: none;
            }

            .btn_view_type_row {
                display: flex;
                align-items: center;
                gap: 10px;
                flex-wrap: wrap;
                margin-bottom: 14px;
            }

            .btn_view_type {
                min-width: 145px;
                height: 38px;
                margin-bottom: 0;
                padding: 0 12px;
                background-color: #f1f4ff;
                border-radius: 8px;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: space-between;

                .btn_view_title {
                    font-size: 14px;
                    color: #000000;
                    font-weight: 600;
                }
            }

            .btn_view_type_actions {
                margin-left: auto;
            }

            .btn_view_icon i {
                display: none;
                color: #366AFF;
                font-size: 14px;
            }

            .btn_view_type_active {
                border: 1px solid #366aff;
                background-color: #eaf0ff;

                .btn_view_icon i {
                    display: inline-block;
                }
            }

            .shortcut_content_list_head {
                width: 600px;
                display: flex;
                align-items: center;
                margin-bottom: 10px;

                .shortcut_content_title {
                    font-size: 14px;
                    color: #000000;
                    width: 180px;
                    box-sizing: border-box;
                    padding-left: 45px;
                }

                .shortcut_content_desc {
                    font-size: 14px;
                    color: #000000;
                }
            }

            .drop_content {
                width: 600px;
            }

            .shortcut_btn_item {
                width: 600px;
                display: flex;
                align-items: center;
                margin-bottom: 12px;
                position: relative;

                .shortcut_btn_item_left {
                    width: 30px;
                    height: 40px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 8px;

                    i {
                        color: #366aff;
                        cursor: move;
                    }
                }

                .shortcut_btn_content {
                    flex: 1;
                    display: flex;
                    align-items: center;
                    height: 40px;
                    background-color: #f1f4ff;
                    border-radius: 8px;
                    padding: 4px 12px;
                    position: relative;

                    .shortcut_btn_title {
                        width: 128px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        margin-right: 10px;
                    }

                    .shortcut_btn_desc {
                        width: calc(100% - 188px);
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        // background: #666666;
                    }

                    .shortcut_btn_set {
                        position: absolute;
                        right: 10px;
                        top: 50%;
                        transform: translateY(-50%);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 35px;
                        height: 24px;
                        background-color: #366aff;
                        border-radius: 30px;
                        cursor: pointer;

                        i {
                            color: #FFFFFF;
                            font-size: 14px;
                        }
                    }
                }

                .shortcut_btn_item_right {
                    position: absolute;
                    right: -25px;
                    top: 50%;
                    transform: translateY(-50%);
                    cursor: pointer;

                    i {
                        color: #366aff;
                    }
                }
            }

            .shortcut_btn_add {
                width: 70px;
                height: 40px;
                display: flex;
                align-items: center;
                cursor: pointer;
                margin-left: 32px;

                .shortcut_btn_add_icon {
                    width: 28px;
                    height: 28px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background-color: #366aff;
                    border-radius: 4px;
                    color: #FFFFFF;
                    font-size: 20px;
                    margin-right: 12px;

                    i {
                        font-size: 14px;
                    }

                }

                >span {
                    color: #366AFF;
                }
            }

            .agent_drop_content {
                width: 100%;
            }

            .agent_list {
                width: 100%;
                height: auto;
                margin-bottom: 20px;

                .agent_list_item {
                    width: 100%;
                    height: 40px;
                    display: flex;
                    align-items: center;
                    margin-bottom: 10px;
                    cursor: pointer;

                    img {
                        width: 30px;
                        height: 30px;
                        border-radius: 4px;
                        margin-right: 10px;
                    }

                    span {
                        font-size: 14px;
                        color: #000000;
                    }
                }
            }
        }

        .shortcut_right {}
    }

    .dialogView {
        width: 375px;
        box-sizing: border-box;
        height: 100%;
        // margin-left: 15px;
        position: absolute;
        border-radius: 4px;
        right: -390px;
        top: 0;
    }

    .p-content {
        .btn_name {
            margin: 12px 0;
        }

        .btn_name_input {
            width: 100%;
            height: 36px;
            display: flex;
            align-items: center;
            // justify-content: space-between;
            border: 1px solid #DCDFE6;
            border-radius: 4px;
            margin-top: 12px;
            padding: 0 12px;
            box-sizing: border-box;

            // padding-left: 2px;
            .icon_set_btn {
                width: 28px;
                height: 28px;
                font-size: 18px;
                color: #616161;
                display: flex;
                align-items: center;
                justify-content: center;
                background: #F5F7FB;
                cursor: pointer;
                margin-right: 10px;
                border-radius: 4px;
                // margin: 0 5px;
            }

            .el-input {
                height: auto;
                /* margin: 0 10px 0 !important;*/
            }

            /deep/.el-input__inner {
                // height: 38px !important;
                width: 100%;
                border: none;
                background: transparent;
                padding: 0;
            }

            /deep/.el-input__inner::placeholder {
                color: #c0c4cc !important;
            }

            /deep/.el-input__inner:focus {
                border: none;
                box-shadow: none;
            }

            .el-dropdown {
                margin: 0 12px;
            }

            .agent_name {
                display: flex;
                align-items: center;
                width: 100%;
                cursor: pointer;
                margin: 0 12px;
                color: #606266;
                min-width: 130px;

                .agent_name_text {
                    // max-width: 115px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .agent_name_text_placeholder {
                    color: #c0c4cc;
                }


                .as_name_text {
                    // max-width: 155px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .as_name_text_placeholder {
                    color: #c0c4cc;
                }

                img {
                    width: 24px;
                    height: 24px;
                    border-radius: 4px;
                    margin-right: 8px;
                }
            }

        }

        .btn_name_input_plugin {
            .agent_name {
                max-width: 170px;
            }
        }

        .switch-cont {
            display: flex;
            align-items: center;
            margin: 12px 0;

            .item-title {
                margin-left: 12px;
                margin-right: 8px;

                .item-title-warnning {
                    display: inline-block;
                    border-radius: 5px;
                    padding: 0 5px;
                    font-size: 12px;
                    color: red;
                    background-color: rgb(254, 240, 240);
                }
            }

            /deep/ .switch {
                display: flex;
                flex-direction: row;
                height: 25px;
                justify-content: space-between;
                cursor: pointer;
                position: relative;
                text-align: center;
                align-items: center;

                .el-switch {
                    text-align: center;
                }

                .switch-open-icon {
                    position: absolute;
                    // z-index: 999;
                    top: 50%;
                    transform: translateY(-50%);
                    left: 3px;

                    i {
                        color: white;
                        font-size: 16px;
                    }
                }

                .switch-close-icon {
                    position: absolute;
                    // z-index: 999;
                    top: 50%;
                    transform: translateY(-50%);
                    left: 21px;

                    i {
                        color: #6e6b7b;
                        font-size: 14px;
                        font-weight: 600;
                    }
                }

                i {
                    color: #366aff;
                    font-size: 18px;
                }

                .el-switch__core::after {
                    width: 14px;
                    height: 14px;
                    top: 2px;
                    left: 2px;
                }

                .is-checked .el-switch__core::after {
                    left: 40px;
                }

                &.disabled {

                    i,
                    .el-switch__input,
                    .el-switch__core {
                        cursor: no-drop;
                    }
                }
            }

        }
    }

    /deep/#popup-assembly {
        width: 700px !important;
    }
}
</style>
<style lang="less">
.icon_popover {
    width: 500px;
    background-color: #FFFFFF;

    .icon_content {
        width: 500px;

        .icon_list {
            width: 100%;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            margin-bottom: 12px;

            .icon_item {
                width: 30px;
                height: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;

                i {
                    font-size: 18px;
                    color: #616161;
                }
            }

            .icon_item:hover {
                .icon {
                    background-color: #366aff !important;
                }

                .iconfont {
                    color: #366aff !important;
                }

            }
        }

        .icon_upload {
            display: flex;
            align-items: center;
            width: 100%;

            .upload_btn {
                width: 32px;
                height: 32px;
                // border: 1px ;
                // 粗的虚线边框
                border: 1px dashed #366AFF;
                border-radius: 4px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                color: #366AFF;

            }

            .des {
                font-size: 13px;
                color: #616161;
                margin-left: 10px;

                a {
                    color: #366AFF;
                    cursor: pointer;
                    text-decoration-line: line;
                }
            }
        }
    }
}

.group_list {
    margin-bottom: 14px;
}

.group_list_item {
    height: 34px;
    background: #f6f8ff;
    border-radius: 6px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
}

.group_name {
    font-size: 14px;
    color: #303133;
    font-weight: 600;
}

.group_ops {
    display: flex;
    align-items: center;
    gap: 10px;
    color: #606266;
    cursor: pointer;
}

.agent_info_dropdown {
    display: flex;
    align-items: center;
    // justify-content: space-between;
    width: 200px;
    cursor: pointer;

    img {
        width: 24px;
        height: 24px;
        border-radius: 4px;
        margin-right: 12px;
    }

    .agent_name_info {
        width: calc(100% - 36px);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 14px;
    }
}

.tree-popover {
    .el-tree-node__content {
        height: 32px !important;
    }

    .custom-tree-node {
        height: 32px !important;

        .node-left {
            display: flex;
            align-items: center;
            width: calc(100% - 20px);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        img {
            width: 24px;
            height: 24px;
            border-radius: 4px;
            margin-right: 8px;
        }
    }
}
</style>
